import { render, staticRenderFns } from "./CookieConsentBanner.vue?vue&type=template&id=2ba45796&scoped=true&"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=js&"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=js&"
import style0 from "./CookieConsentBanner.vue?vue&type=style&index=0&id=2ba45796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba45796",
  null
  
)

export default component.exports